import { useTheme } from '@mui/material/styles';
import React from 'react';
import Box from '@mui/material/Box';
import ModalFooter from './common/ModalFooter';
import Modal from '../components/common/Modal';
import RadioButton from '../components/common/RadioButton';
import Typography from '@mui/material/Typography';

interface TypeOption {
  value: string;
  label: string;
}

interface SelectTypeModalProps {
  open: boolean;
  onClose: () => void;
  selectedType: string;
  onChangeType: (_type: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  typeOptions: TypeOption[];
  confirmButtonLabel: string;
  title?: string;
  typesLabel?: string;
  error?: string | null;
}

const SelectTypeModal: React.FC<SelectTypeModalProps> = ({
  open,
  onClose,
  selectedType,
  onChangeType,
  onConfirm,
  onCancel,
  isSubmitting = false,
  typeOptions,
  confirmButtonLabel,
  title,
  typesLabel,
  error,
}) => {
  const theme = useTheme();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="md"
      headerSx={{ height: 40, px: 3.75, py: 2 }}
      contentSx={{ p: 0 }}
      contentDividers={false}
      actionsDivider={false}
      actionsSx={{ px: 3.75, py: 2 }}
      footer={
        <ModalFooter
          onCancel={onCancel}
          onSubmit={onConfirm}
          isLoading={isSubmitting}
          submitText={confirmButtonLabel}
        />
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {typesLabel && (
          <Box
            sx={{
              height: 55,
              px: 3.75,
              py: 2,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography sx={{ fontWeight: 500, fontSize: 16, color: theme.palette.modal.title }}>
              {typesLabel}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            px: 3.75,
            pb: 3,
            display: 'flex',
            gap: 2,
            pt: typesLabel ? 0 : 3,
          }}
        >
          {typeOptions.map((type) => (
            <RadioButton
              key={type.value}
              checked={selectedType === type.value}
              onChange={() => onChangeType(type.value)}
              label={type.label}
            />
          ))}
        </Box>
        {error && (
          <Typography sx={{ color: theme.palette.modal.error, fontSize: '14px', mt: 2, px: 3.75 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Modal>
  );
};

export default React.memo(SelectTypeModal);
